import React, { useState } from 'react';

const RentalsExportModal = ({ onClose, data }) => {
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    try {
      setExporting(true);
      const headers = ['Description', 'Total Hours', 'Total Install', 'Hourly', 'Daily', 'Weekly', 'Monthly',
        'Days/Wk', 'Hrs/Day', 'Qty', 'Period Type', 'Duration', 'Basic Rental', 'Fuel Factor', 'Fuel Cost',
        'Mob/Dem', 'Surcharge Factor', 'Surcharge', 'Purchase', 'Total Cost', 'Site Expense', 'Source',
        'Trade', 'From Out', 'Subject To', 'Comments'];
      const keys = ['description', 'total_hours', 'total_install', 'hourly', 'daily', 'weekly', 'monthly',
        'days_wk', 'hrs_day', 'qty', 'period_type', 'duration', 'basic_rental', 'fuel_factor', 'fuel_cost',
        'mob_dem', 'surcharge_factor', 'surcharge', 'purchase', 'total_cost', 'site_expense', 'source',
        'trade', 'from_out', 'subject_to', 'comments'];
      
      let csv = headers.join(',') + '\n';
      data.forEach(row => {
        csv += keys.map(k => {
          const val = row[k] ?? '';
          return typeof val === 'string' && (val.includes(',') || val.includes('"')) ? `"${val.replace(/"/g, '""')}"` : val;
        }).join(',') + '\n';
      });
      
      const blob = new Blob([csv], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `rentals_${new Date().toISOString().split('T')[0]}.csv`;
      a.click();
      URL.revokeObjectURL(url);
      onClose();
    } catch (err) {
      alert('Export failed: ' + err.message);
    } finally {
      setExporting(false);
    }
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
      <div style={{ backgroundColor: '#2a2a3a', padding: '30px', borderRadius: '8px', minWidth: '400px' }}>
        <h3 style={{ color: '#fff', marginTop: 0 }}>Export Rentals</h3>
        <p style={{ color: '#ccc' }}>Export {data.length} records to CSV file?</p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
          <button onClick={onClose} style={{ padding: '10px 20px', backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Cancel</button>
          <button onClick={handleExport} disabled={exporting} style={{ padding: '10px 20px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>{exporting ? 'Exporting...' : 'Export'}</button>
        </div>
      </div>
    </div>
  );
};

export default RentalsExportModal;
